import { GameScore, GameStatus, formatEmptyState } from "common";
import Link from "next/link";
import React from "react";

/**
 * Displays a score for a game in a table where perspective is point of view to determine win or loss.
 */
export default function GameTableScore({
  score,
  home,
  slug,
  relative,
  overtime,
  status,
}: {
  score: GameScore;
  home?: boolean;
  slug?: string;
  relative?: boolean;
  overtime?: boolean;
  status?: GameStatus;
}) {
  const win: boolean =
    (home && score.home > score.away) || (!home && score.away > score.home);
  let exception: string | undefined = undefined;
  let showScore: boolean = true;
  let suffix: string = '';
  if (status !== undefined) {
    switch (status) {
      case "F/OT":
        suffix = "OT";
        break;
      case "F/SO":
        suffix = "SO";
        break;
      case "Delayed":
        exception = `D`;
        break;
      case "Canceled":
        exception = `C`;
        showScore = false;
        break;
      case "Postponed":
        exception = `PP`;
        showScore = false;
        break;
      case "Suspended":
        exception = `S`;
        break;
      default:
        exception = undefined;
    }
  }
  const content: JSX.Element = (
    <div className="flex gap-2 items-center">
      <span className={`${exception ? "text-dark" : win ? "text-success-300" : "text-error-300"}`}>
        {exception ? exception : win ? "W" : "L"}{" "}
      </span>
      {showScore ? (
        <span className="text-dark">
          {relative
            ? home
              ? score.home
              : score.away
            : Math.max(score.home, score.away)}{" "}
          -{" "}
          {relative
            ? home
              ? score.away
              : score.home
            : Math.min(score.home, score.away)}{" "}
          {suffix ? suffix : undefined}
        </span>
      ) : (
        <span className="text-dark">{formatEmptyState("empty")}</span>
      )}
    </div>
  );

  return slug ? (
    <Link href={slug} scroll={false}>
      {content}
    </Link>
  ) : (
    content
  );
}
